import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import useZoomLevel from '../../Optics/Markers/useZoomLevel';
import { iconFob, iconFobCanton, iconWifiAp, iconWifiHotspot } from '../../Optics/Constants/ConstantsOptics';

const MarkersEditingWifiPoint = ({ markers, selectedRankFob, removeMarker, type }) => {

 
  const selectedIcon = selectedRankFob === '1' || selectedRankFob === '2' ? iconWifiAp : iconWifiHotspot;
  const zoomLevel = useZoomLevel();

  if (zoomLevel <= 13) {
    return null;
  }

  return (  
  <>
    {markers.map((marker, index) => (
      <Marker
        key={index}
        position={[marker.lat, marker.lng]}
        icon={selectedIcon}
      >
        <Popup autoClose={false} className="custom-popup">
          <div>
            <label style={{ color: '#555555', fontSize: '16px' }}>{type}</label>
            <hr className="horizontalLinePopup" />
            <button className="popupButtonDelete" onClick={(e) => { e.stopPropagation(); removeMarker(index); }}>Удалить</button>
          </div>
        </Popup>
      </Marker>
    ))}
  </>
  );
}
export default MarkersEditingWifiPoint;
